module.exports = __webpack_public_path__ + "static/after3-6adb49d5dc5ca45d6123ac18b6783673.jpg";